<!--
 * @Author: Admni
 * @Description: 等待列表
 * @Date: 2021-01-29 14:28:30
 * @LastEditTime: 2021-03-03 10:54:28
-->
<template>
  <div id="wait">
    <h1>
      <span>用户列表</span>
      <small>所有能处理的包的用户</small>
    </h1>
    <section class="search">
      <el-form :inline="true" class="search-form" label-width="80px">
        <el-row>
          <el-form-item label="名称">
            <el-input
              v-model="form.u"
              style="width: 260px"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户类型">
            <el-select
              v-model="form.u_level"
              style="width: 260px"
              placeholder="请选择"
            >
              <el-option
                v-for="item in optionLevel"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Ip国家">
            <el-input
              v-model="form.ctr"
              style="width: 260px"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="城市">
            <el-input
              v-model="form.city"
              style="width: 260px"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="isp信息">
            <el-input
              v-model="form.isp"
              style="width: 260px"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="Tag">
            <el-select
              v-model="form.tag"
              multiple
              collapse-tags
              style="width: 260px"
              placeholder="请选择（默认所有）"
            >
              <el-option
                v-for="item in optionTag"
                :key="item.pk"
                :label="item.name"
                :value="item.pk"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="包名">
            <el-select
              v-model="form.pkg"
              multiple
              collapse-tags
              style="width: 260px"
              placeholder="请选择（默认所有）"
            >
              <el-option
                v-for="item in optionsPkg"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围">
            <el-date-picker
              v-model="form.date"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期(默认七天)"
              end-placeholder="结束日期(默认七天)"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" icon="el-icon-search"
              >搜索</el-button
            >
            <el-button
              type="primary"
              @click="reset"
              icon="el-icon-refresh-right"
              >重置</el-button
            >
          </el-form-item>
        </el-row>
      </el-form>
    </section>

    <el-button @click="multipChat" style="margin-top: 15px">发起会话</el-button>
    <span style="font-size: 14px; color: #409eff; margin-left: 20px"
      >批量选中用户群发消息</span
    >
    <div class="table-wrap">
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        border
        ref="multipleTable"
        :header-cell-style="{ background: '#ececf1', color: '#414750' }"
      >
        <el-table-column align="center" type="selection" width="55">
        </el-table-column>
        <el-table-column
          align="center"
          prop="pkg__pkg"
          label="包名"
          width="200"
        >
        </el-table-column>
        <el-table-column align="center" prop="pk" label="Id" width="65">
        </el-table-column>
        <el-table-column
          align="center"
          prop="create_time"
          label="创建时间"
          width="200"
        >
        </el-table-column>
        <el-table-column align="center" prop="account_str" label="用户名称">
        </el-table-column>
        <el-table-column align="center" label="用户类型">
          <template slot-scope="scope">
            <span>{{ scope.row.u_type === 1 ? "付费" : "免费" }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Tag">
          <template slot-scope="scope">
            <span>{{ scope.row.tag__name.join(",") }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="ISP" label="ISP">
        </el-table-column>
        <el-table-column align="center" prop="city" label="城市">
        </el-table-column>
        <el-table-column align="center" prop="ctr" label="国家">
        </el-table-column>
      </el-table>

      <div class="pages">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="1000"
          @current-change="changeCurrent"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog title="发起会话" :visible.sync="dialogVisible" width="30%">
      <el-input v-model="content" placeholder="请输入会话内容"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendChat">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDisList,
  getChatToOur,
  getAllUsers,
  launchChat,
  batchSendMsgs,
} from "@/api/chat.js";
import { fileType } from "../../utils/index";
export default {
  name: "wait-list",
  data() {
    return {
      selectList: [],
      content: "",
      dialogVisible: false,
      loading: false,
      curChatData: [
        {
          ts: 1610517408469,
          msg: "信息9",
          is_b: false,
        },
        {
          ts: 1610521780448,
          msg: "xxx",
          is_b: true,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      optionsPkg: [],
      optionTag: [],
      form: {
        pkg: [],
        isp: "",
        u: "",
        u_level: "",
        ctr: "",
        city: "",
        tag: [],
        date: [],
      },
      page: 0,
      tableData: [],
      optionLevel: [
        {
          label: "免费",
          value: 0,
        },
        {
          label: "付费",
          value: 1,
        },
      ],
    };
  },
  mounted() {
    let _group = JSON.parse(localStorage.getItem("pkg"));
    let resList = [];
    _group.forEach((gVal) => {
      resList.push({
        value: gVal.pkg,
        label: gVal.pkg,
      });
    });
    this.optionsPkg = resList;

    let _localTags = JSON.parse(localStorage.getItem("tag")).tags;
    let tList = [];
    _localTags.forEach((tVal) => {
      tList.push({
        pk: tVal.pk,
        name: tVal.name,
      });
    });
    this.optionTag = tList;

    this.getData();
  },
  methods: {
    getData() {
      let params = JSON.parse(JSON.stringify(this.form));
      params.pkg = this.form.pkg.join(",");
      params.tag = this.form.tag.join(",");

      delete params.date;
      params.st =
        this.form.date && this.form.date.length > 0 ? this.form.date[0] : "";
      params.et =
        this.form.date && this.form.date.length > 0 ? this.form.date[1] : "";
      params.left = this.page;
      this.loading = true;

      getAllUsers(params)
        .then((res) => {
          let _list = [];
          for (let key in res) {
            _list.push(res[key]);
          }
          _list.sort((a, b) => {
            let _arr = new Date(a.create_time).getTime()
            let _prev = new Date(b.create_time).getTime()
            return _prev - _arr
          })

          this.tableData = _list;
          this.loading = false;
        })
        .catch((err) => {
          this.$message({
            message: err,
            type: "warning",
          });
          this.loading = false;
        });
    },
    onSubmit() {
      this.getData();
    },
    reset() {
      this.form = this.$options.data.call(this).form;
      this.getData();
    },
    changeCurrent(val) {
      this.page = val - 1;
      this.getData();
    },
    multipChat() {
      let _selectData = this.$refs.multipleTable.selection;
      let ids = [];

      if (_selectData.length === 0) {
        this.$message({
          message: "请选中要发送的用户",
          type: "warning",
        });
        return;
      }
      _selectData.map((item) => {
        ids.push({
          pk: item.pk,
          u_name: item.account_str, 
          pkg: item.pkg__pkg,
        });
      });
      this.selectList = ids;
      this.dialogVisible = true;
    },
    sendChat() {
      if (!this.content) {
        this.$message({
          message: "发送内容不能为空",
          type: "warning",
        });
        return false;
      }

      let params = {
        i: this.selectList,
        msg: this.content,
      };

      batchSendMsgs(params).then((res) => {
        this.dialogVisible = false;
        this.content = "";
        this.$message({
          message: "发送成功",
          type: "success",
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#wait {
  width: 100%;
  min-height: calc(100vh - 50px);
  padding: 20px;
  background: #eff1f7;
}
h1 {
  font-size: 20px;
  font-weight: 400;
  small {
    margin-left: 15px;
    font-size: 15px;
    color: #777777;
  }
}
.search {
  padding: 20px 20px 0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  background: #ffffff;
}
.table-wrap {
  padding: 5px;
  margin-top: 20px;
  border: 1px solid #e4e4e4;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  background: #ececf1;
}
.pages {
  display: flex;
  justify-content: flex-end;
  margin: 15px 0;
  width: 100%;
}
</style>
